function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import PropTypes from 'prop-types';
import defaultPropTypes from '../../utils/prop-types';
import { renderComponents } from '../../utils/convenience';
import ListItem from './list-items/list-item';
import FilterList from '../filter-list';
var DISABLED_CLASS_NAME = 'disabled';
var INITIAL_PAGER_STATE = {
  currentPage: 0
};
var ListPager = function ListPager(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "pager"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pager-status"
  }, "Showing ", /*#__PURE__*/React.createElement("span", {
    className: "page-end"
  }, props.currentEnd), " out of", /*#__PURE__*/React.createElement("span", {
    className: "page-total"
  }, props.totalRecords), " Results"), /*#__PURE__*/React.createElement("div", {
    className: "pager-buttons"
  }, /*#__PURE__*/React.createElement("a", {
    // eslint-disable-line jsx-a11y/anchor-is-valid
    role: "button",
    className: "pager-append-next-button ".concat(props.disableNext),
    onClick: function onClick(e) {
      props.nextPageClick(props.currentPage, e);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.keyCode === 13) {
        props.nextPageClick(props.currentPage, e);
      }
    },
    disabled: props.disableNext === DISABLED_CLASS_NAME
  }, "Show More Results")));
};
var ListLoadMore = /*#__PURE__*/function (_React$Component) {
  function ListLoadMore(props) {
    var _this;
    _classCallCheck(this, ListLoadMore);
    _this = _callSuper(this, ListLoadMore, [props]);
    _this.props.settings.ListCount = 20;
    _this.handleNextPageClick = _this.handleNextPageClick.bind(_this);
    _this.state = INITIAL_PAGER_STATE;
    _this.state.locationsStateHash = _this.props.locationsStateHash;
    return _this;
  }
  _inherits(ListLoadMore, _React$Component);
  return _createClass(ListLoadMore, [{
    key: "setPagerState",
    value: function setPagerState(currentPage) {
      this.setState({
        currentPage: currentPage
      });
    }
  }, {
    key: "calculatePageState",
    value: function calculatePageState(currentPage) {
      var maxPages = Math.ceil(this.props.locations.length / this.props.settings.ListCount) - 1; // Page numbers start at 0

      var currentStartRecord = this.props.locations.length > 0 ? currentPage * this.props.settings.ListCount + 1 : 0;
      var currentEndRecord = Math.min((currentPage + 1) * this.props.settings.ListCount, this.props.locations.length);
      var disableNextButton = currentPage >= maxPages ? DISABLED_CLASS_NAME : '';
      return {
        currentStartRecord: currentStartRecord,
        currentEndRecord: currentEndRecord,
        disableNextButton: disableNextButton
      };
    }
  }, {
    key: "handleNextPageClick",
    value: function handleNextPageClick(page, e) {
      var numOfPages = Math.ceil(this.props.locations.length / this.props.settings.ListCount);
      if (page <= numOfPages) {
        var currentPage = page + 1;
        this.setPagerState(currentPage);
      }
      e.preventDefault();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var ItemView = this.props.listItemView;
      var startLocationIndex = this.props.settings.ListCount * this.state.currentPage;
      var truncatedLocations = this.props.locations.slice(0, this.props.settings.ListCount + startLocationIndex);
      var pageState = this.calculatePageState(this.state.currentPage);
      return /*#__PURE__*/React.createElement("div", {
        className: "locations-list ".concat(this.props.layoutType)
      }, this.props.filterListOpen && /*#__PURE__*/React.createElement(FilterList, this.props), !this.props.filterListOpen && /*#__PURE__*/React.createElement(React.Fragment, null, renderComponents('header', this.props.header, this.props), /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, truncatedLocations.map(function (location, index) {
        return /*#__PURE__*/React.createElement(ItemView, Object.assign({
          key: "locationItem-".concat(location.UniqueId),
          location: location,
          index: index
        }, _this2.props));
      }), /*#__PURE__*/React.createElement(ListPager, _extends({
        nextPageClick: this.handleNextPageClick,
        currentStart: pageState.currentStartRecord,
        currentEnd: pageState.currentEndRecord,
        currentPage: this.state.currentPage,
        totalRecords: this.props.locations.length,
        disableNext: pageState.disableNextButton
      }, this.props))), renderComponents('footer', this.props.footer, this.props)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, theState) {
      if (nextProps.locationsStateHash !== theState.locationsStateHash) {
        var newState = INITIAL_PAGER_STATE;
        newState.locationsStateHash = nextProps.locationsStateHash;
        return newState;
      }
      return null;
    }
  }]);
}(React.Component);
export default ListLoadMore;
ListLoadMore.propTypes = {
  selectedLocation: defaultPropTypes.location,
  openLocation: defaultPropTypes.location,
  locations: defaultPropTypes.locations,
  onSelectLocation: defaultPropTypes.func,
  onOpenLocation: defaultPropTypes.func,
  onCloseFilterList: defaultPropTypes.func,
  onChangeFilter: defaultPropTypes.func,
  layoutType: defaultPropTypes.layoutType,
  settings: defaultPropTypes.settings,
  header: PropTypes.arrayOf(PropTypes.element),
  footer: PropTypes.arrayOf(PropTypes.element),
  listItemView: PropTypes.func,
  filterListOpen: PropTypes.bool,
  locationsStateChanged: PropTypes.string,
  locationsStateHash: PropTypes.string.isRequired
};
ListLoadMore.defaultProps = {
  selectedLocation: defaultPropTypes.defaultLocation(),
  openLocation: defaultPropTypes.defaultLocation(),
  locations: defaultPropTypes.defaultLocations,
  onSelectLocation: defaultPropTypes.defaultOnSelectLocation,
  onOpenLocation: defaultPropTypes.defaultOnOpenLocation,
  onCloseFilterList: defaultPropTypes.defaultOnCloseFilterList,
  onChangeFilter: defaultPropTypes.defaultOnChangeFilter,
  layoutType: defaultPropTypes.defaultLayoutType,
  settings: defaultPropTypes.defaultSettings,
  header: [],
  footer: [],
  listItemView: ListItem,
  filterListOpen: false,
  locationsStateChanged: ''
};
ListPager.propTypes = {
  currentEnd: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  nextPageClick: PropTypes.func.isRequired,
  totalRecords: PropTypes.number.isRequired,
  disableNext: PropTypes.string.isRequired
};